import React from "react";

function SkillGroup({ group }) {
  return (
    <div className="skill-group">
      <div className="skill-label">{group.group}</div>
      <div className="skill-items">
        {group.items.map((s) => <span className="chip" key={s}>{s}</span>)}
      </div>
    </div>
  );
}

export default function Skills({ groups }) {
  return (
    <div className="skills">
      {groups.map((g) => <SkillGroup key={g.group} group={g} />)}
    </div>
  );
}
